import CSVColumnsStrategy from '../CSVColumnsStrategy'

export default function CostCSVPreviewBaseColumnsStrategy() {}

CostCSVPreviewBaseColumnsStrategy.prototype = new CSVColumnsStrategy();

CostCSVPreviewBaseColumnsStrategy.prototype.init = function (showSpentTime, showAverageRates)
{
    CSVColumnsStrategy.prototype.init.call( this );
    this.showSpentTime = showSpentTime;
    this.showAverageRates = showAverageRates;
    return this;
};

CostCSVPreviewBaseColumnsStrategy.prototype.getNumOfDataColumns = function ()
{
    return this.getOverallColumnsCount() + this.getNumOfDetailsColumns();
};

CostCSVPreviewBaseColumnsStrategy.prototype.getNumOfDetailsColumns = function ()
{
    //abstract
};



CostCSVPreviewBaseColumnsStrategy.prototype.getOverallColumnsCount = function ()
{
    var count = 1;
    if (this.showSpentTime) count++;
    if (this.showAverageRates) count++;
    return count;
};

CostCSVPreviewBaseColumnsStrategy.prototype.addOverallHeaderCells = function( row )
{
    if( this.showSpentTime )
        this.addCell( row, this.message( "report.cost.overall_spent.csv" ) );
    if( this.showAverageRates )
        this.addCell( row, this.message( "report.cost.average_rate.csv", [SystemSettings.currencySign] ));
    this.addCell( row, this.message( "report.cost.overall_cost.csv", [SystemSettings.currencySign] ));
};

CostCSVPreviewBaseColumnsStrategy.prototype.addThirdHeaderRowDataCells = function(mainHeaderRow){

};

CostCSVPreviewBaseColumnsStrategy.prototype.getCountLevels = function ( colGroupingRow )
{
    // abstract
};

CostCSVPreviewBaseColumnsStrategy.prototype.addFirstHeaderRowDataCells = function( row )
{

};

CostCSVPreviewBaseColumnsStrategy.prototype.addSecondHeaderRowDataCells = function(row){

};



CostCSVPreviewBaseColumnsStrategy.prototype.addDataCells = function ( row )
{
    for( var i = 0; i < this.getNumOfDataColumns(); i++ )
        this.addTimeValueCell( row );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewBaseColumnsStrategy.js